
import { Quote } from '@tenants/types/tenant';
import { Namespaces } from 'types/locales';

import type { joinExpCaPaths, joinExpUsPaths } from 'types/locales';

export function createLeoParejaQuote(namespace: typeof Namespaces.JOIN_EXP_US | typeof Namespaces.JOIN_EXP_CA, highlightColor: string, spanClassName: string) {

  const authorTitle: joinExpCaPaths | joinExpUsPaths = `${namespace}:leoQuote.authorTitle`;
  const quoteContent: joinExpCaPaths | joinExpUsPaths = `${namespace}:leoQuote.quoteContent`;

  const leoParejaQuote: Quote = {
    authorImage: '/next/assets/images/join-expus/Leo.jpg',
    authorImageAlt: 'Leo Pareja',
    authorTitle,
    authorName: 'Leo Pareja',
    quoteContent,
    className: { span: spanClassName },
    highlightColor,
  };
  return leoParejaQuote;
}

export function createGlennSanfordQuote(namespace: typeof Namespaces.JOIN_EXP_US | typeof Namespaces.JOIN_EXP_CA, highlightColor: string, spanClassName: string) {

  const authorTitle: joinExpCaPaths | joinExpUsPaths = `${namespace}:glennQuote.authorTitle`;
  const quoteContent: joinExpCaPaths | joinExpUsPaths = `${namespace}:glennQuote.quoteContent`;

  const glennSanfordQuote: Quote = {
    authorImage: '/next/assets/images/join-expus/Glenn.jpg',
    authorImageAlt: 'Glenn Sanford',
    authorTitle,
    authorName: 'Glenn Sanford',
    quoteContent,
    className: { span: spanClassName },
    highlightColor,
  };

  return glennSanfordQuote;
}